import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=2362701d&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=2362701d&prod&lang=less&scoped=true"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=2362701d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2362701d",
  null
  
)

export default component.exports